import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_NGO_REG_001_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const searchRef = useRef<any>(null);
    //#endregion
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getSelectedRows() || [],
        gridRefs.current["grid2"].current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_TRA_NGO_REG_001_POP_002",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_tra_ngo_reg_001_03",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(param);

          setDataSources({
            grid1: data[0] || [],
            grid2: data[1] || [],
          });

          gridRefs.current["grid1"].current.resetUpdate();
          gridRefs.current["grid2"].current.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event?.data || event;

      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        gridRefs.current["grid2"].current.applyFilters({ cd_cust: cd_cust });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
      }
    };
    //#endregion
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
            //onRowDataReady,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
      }),
      [columns, dataSources]
    );

    //#region UI
    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div style={{ height: "28vh", marginTop: "10px" }}>
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
            }}
            events={grids.grid1.events}
          />

          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
            }}
          />
        </div>
      </div>
    );
    //#endregion
  }
);

export default SN_TRA_NGO_REG_001_POP_002;
